import { render, staticRenderFns } from "./FilialBadge.vue?vue&type=template&id=12a313fb&scoped=true&"
import script from "./FilialBadge.vue?vue&type=script&lang=js&"
export * from "./FilialBadge.vue?vue&type=script&lang=js&"
import style0 from "./FilialBadge.vue?vue&type=style&index=0&id=12a313fb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a313fb",
  null
  
)

export default component.exports